
import axios from "axios";
import { Component, createRef, Fragment } from "react";
import './App.css';
import FooterCCDMD from './components/FooterCCDMD/FooterCCDMD';
import ILabyData, { ILabyUrlParams } from './interfaces/ILabyData';
import { getAllUrlParams } from './utils/utils';
import GameManager from './components/GameManager/GameManager';
import AudioManager from './components/AudioManager/AudioManager';
import PopupManager from "./components/PopupManager/PopupManager";

const dataUrl = "./laby_data.json";

class App extends Component<any,any> {
  
  gameManager= createRef<GameManager>();
  popupManager= createRef<PopupManager>();
  audioManager= createRef<AudioManager>();

  urlParams:ILabyUrlParams;
  donneesLaby?:ILabyData;
  footerRef:FooterCCDMD|null = null;

  constructor(props:any){
    super(props);
    this.urlParams = getAllUrlParams(window.location);
    this.state = {
      error: null,
      isLoaded: false,
    }
  }

  componentDidMount(){
    axios.get(dataUrl).then((response) => {
      this.donneesLaby = (response.data.laby); 
      
      if (this.props.footerRef && this.props.footerRef.current){
        this.footerRef = this.props.footerRef.current;
        this.footerRef?.setVersionNumber(this.donneesLaby?.version_app, this.donneesLaby?.version_donnees);
      }
      this.setState({
        isLoaded:true
      })
      this.gameManager.current?.onIsLoaded();
    });
  }

  render() {
    if (!this.state.isLoaded){
      // Chargement des données
      return(
        <h1>Donnees manquantes</h1>
      );

    } else {
      // Affichage de l'interface de jeu
      return(
        <Fragment>
            <GameManager ref={this.gameManager} app={this}/>
            <PopupManager ref={this.popupManager} app={this} />          
            <AudioManager ref={this.audioManager} app={this} />          
          
        </Fragment>
      );
    }
    
  }
}

export default App;
